/** @format */

import React from 'react';
import { ApplicationDetailsDto } from '../../Models';
import { Box, Stack, Typography } from '@mui/material';
import { useAppSelector } from '../../../../app/hooks';
import { selectConstants } from '../../../../common/dropdowns/Api/constantSlice';

interface Props {
  applicant: ApplicationDetailsDto;
}

function Field({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <Box>
      <Typography
        variant='caption'
        sx={{
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          color: 'text.secondary',
          display: 'block',
          mb: 0.5,
        }}>
        {label}
      </Typography>
      <Typography variant='body2' sx={{ fontWeight: 600, color: 'text.primary' }}>
        {children}
      </Typography>
    </Box>
  );
}

export default function StudyInfo({ applicant }: Props) {
  const constantsSelect = useAppSelector(selectConstants);

  const getProvince = (key: number | string) => {
    const findProvince = constantsSelect.constantState?.provinces.find(
      (x) => x.id === key
    );
    return findProvince?.description;
  };

  const getSubjects = (key: number[]) => {
    const array: string[] = [];
    if (!constantsSelect.constantState?.subjects) return '';
    for (let x = 0; x < key.length; x++) {
      const val = key[x];
      const findSubjects = constantsSelect.constantState.subjects.find(
        (j) => j.id === val
      );
      if (findSubjects) {
        array.push(findSubjects.description);
      }
    }
    return array.join(', ');
  };

  if (!applicant?.education) return null;

  return (
    <Stack spacing={2.25}>
      <Field label='High school name'>{applicant.education.highSchoolName}</Field>
      <Field label='Still in high school'>
        {parseInt(applicant.education.matriculationYear.toString(), 10) >=
        new Date().getFullYear()
          ? 'Yes'
          : 'No'}
      </Field>
      <Field label='Matriculation year'>
        {applicant.education.matriculationYear}
      </Field>
      <Field label='High school province'>
        {getProvince(applicant.education.provinceId)}
      </Field>
      <Field label='High school subjects'>
        {getSubjects(applicant.education.subjectIds as number[])}
      </Field>
    </Stack>
  );
}
